import { assertNever } from '@eversports/utility-types'
import React from 'react'
import { PolicyType } from '../../../graphql'

import { Policy as AdditionalInformationPolicyType } from '../../../typings/AdditionalInformation'

import PrivacyPolicy from './PrivacyPolicy'
import TermsOfServicePolicy from './TermsOfServicePolicy'

const Policy: React.FC<React.PropsWithChildren<AdditionalInformationPolicyType>> = ({ type, url }) => {
  switch (type) {
    case PolicyType.POLICY_TYPE_PRIVACY:
      return <PrivacyPolicy url={url} />
    case PolicyType.POLICY_TYPE_TERMS_OF_SERVICE:
      return <TermsOfServicePolicy url={url} />
    default:
      return assertNever(type)
  }
}

export default Policy
